export function isValidIsraeliID(id) {
    id = String(id).trim().replace(/[^0-9]/g, '');
    while (id.length < 9) {
        id = '0' + id;
    }
    if (id.length !== 9 || isNaN(id)) {
        return false;
    }
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        let num = Number(id[i]) * ((i % 2) + 1);
        if (num > 9) num -= 9;
        sum += num;
    }
    return sum % 10 === 0;
}

export function isOnlyNumbers(input) {
    const str = String(input).trim();
    return /^[0-9]+$/.test(str);
}
export function isValidPassport(passport) {
    const str = String(passport).trim().toUpperCase();
    return /^[A-Z0-9]{6,15}$/.test(str);
}




export function isValidPhoneNumber(phone) {
    if (!phone && phone !== 0) return false;
    const phoneStr = String(phone).trim();
    if (!/^[0-9-]+$/.test(phoneStr)) {
        return false;
    }
    const cleaned = phoneStr.replace(/-/g, '');
    return cleaned.length === 10 || cleaned.length === 9 || cleaned.length === 7;
}

export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}